import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'timeAgo',
})
export class TimeAgoPipe implements PipeTransform {

  transform(value: string | Date): string {
    if (!value) return '';

    const now = new Date().getTime();
    const date = new Date(value).getTime();

    if (Number.isNaN(date)) return '';

    const seconds = Math.floor((now - date) / 1000);

    if (seconds < 60) {
      return `${seconds} seconden geleden`;
    }

    const minutes = Math.floor(seconds / 60);

    if (minutes < 60) {
      return `${minutes} minuten geleden`;
    }

    const hours = Math.floor(minutes / 60);

    if (hours < 24) {
      return `${hours} uur geleden`;
    }

    const days = Math.floor(hours / 24);

    if (days < 30) {
      return `${days} dagen geleden`;
    }

    const months = Math.floor(days / 30);

    if (months < 12) {
      return `${months} maanden geleden`;
    }

    const years = Math.floor(months / 12);

    return `${years} jaar geleden`;
  }

}
